import { useTranslation } from 'react-i18next';
export const useTranslations = <T, K extends keyof T>(obj: Partial<T>, options: object, ...keys: K[]): Pick<T, K> => {
  const { t } = useTranslation();
  keys.forEach(key => (obj[key] = t(key as string, options)));
  return obj as any;
};
